// Sidebar imports
import {
  UilEstate,
  UilClipboardAlt,
  //UilUsersAlt,
  UilPackage,
  UilChart,
  //UilSignOutAlt,
  UilPen,
  UilFileAlt,
  UilShoppingCart,
  UilListUl,
} from "@iconscout/react-unicons";

import { useEffect, useState } from "react";
// import { UilChart } from "@iconscout/react-unicons";

import { UilWebGrid } from "@iconscout/react-unicons";
import { UilRefresh } from "@iconscout/react-unicons";
import { UilLayerGroup, UilApps } from "@iconscout/react-unicons";
import { UilUsdSquare, UilMoneyWithdrawal } from "@iconscout/react-unicons";
import { UilHistory } from "@iconscout/react-unicons";
import { UilUtensils } from "@iconscout/react-unicons";

import api from "../utils/api"; //

export const SidebarData = [
  {
    icon: UilEstate,
    heading: "Dashboard",
    link: "/dashboard",
  },
  {
    icon: UilClipboardAlt,
    heading: "Product Management",
    submenu: [
      { heading: "Products", link: "/product" },
      { heading: "Category", link: "/categories" },
      { heading: "Subcategory", link: "/subcategories" },
      { heading: "Update", link: "/price-update" },
      { heading: "Report", link: "/reports" },
    ],
  },
  {
    icon: UilWebGrid,
    heading: "Banner",
    link: "/banner",
  },
  {
    icon: UilUtensils,
    heading: "Table Bookings",
    link: "/table-booking",
  },
  {
    icon: UilListUl,
    heading: "Online Orders",
    link: "/orderdetails",
  },
  {
    icon: UilPen,
    heading: "Takeaway",
    link: "/takeaway",
  },
  {
    icon: UilChart,
    heading: "Report",
    link: "/orders-history",
  },

  //   {
  //   icon: UilPen,
  //   heading: 'Qr Booking',
  //   link:"/qrordering",
  // },
  {
    icon: UilHistory,
    heading: "User Management",
    submenu: [
      {
        heading: "Add User",
        link: "/addusers",
      },
      {
        heading: "Change Password",
        link: "/change-password",
      },
    ],
  },
];

export const useDashboardData = () => {
  const [cardsData, setCardsData] = useState([
    {
      title: "Today's Sales",
      icon: "shopping",
      color: "bg-blue-200 border-blue-400",
      link: "/orders-history",
      series: [{ name: "Sales", data: [0] }],
    },
    {
      title: "Total Orders",
      icon: "shopping",
      color: "bg-emerald-200 border-emerald-400",
      link: "/orders-history",
      series: [{ name: "Total", data: [0] }],
    },
    {
      title: "Weekly Orders",
      icon: "calendar",
      color: "bg-violet-200 border-violet-400",
      link: "/orders-history",
      series: [{ name: "Weekly", data: [0] }],
    },
    {
      title: "Monthly Orders",
      icon: "calendar",
      color: "bg-rose-200 border-rose-400",
      link: "/orders-history",
      series: [{ name: "Monthly", data: [0] }],
    },
    {
      title: "Customer Rating",
      icon: "check",
      color: "bg-amber-200 border-amber-400",
      link: "/feedback",
      series: [{ name: "Rating", data: [0] }],
    },
    {
      title: "Total Products",
      icon: "box",
      color: "bg-cyan-200 border-cyan-400",
      link: "/product",
      series: [{ name: "Products", data: [0] }],
    },
  ]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await api.get("/orders/order-stats");

      const {
        totalOrders = 0,
        todayOrders = 0,
        weeklyOrders = 0,
        monthlyOrders = 0,
        todaySales = 0,
        totalProducts = 0,
        customerRating = 0,
      } = response.data;

      setCardsData((prevData) =>
        prevData.map((card, index) => {
          let value = 0;

          switch (index) {
            case 0: // Today Sales
              value = todaySales;
              break;
            case 1: // Total Orders
              value = totalOrders;
              break;
            case 2: // Weekly Orders
              value = weeklyOrders;
              break;
            case 3: // Monthly Orders
              value = monthlyOrders;
              break;
            case 4: // Customer Rating
              value = customerRating;
              break;
            case 5: // Total Products
              value = totalProducts;
              break;
            default:
              value = 0;
          }

          return {
            ...card,
            series: [{ name: card.title, data: [value] }],
          };
        })
      );
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  fetchData();
}, []);


  return cardsData;
};
